module.exports = __webpack_public_path__ + "static/media/dashboard_light.4a346f8c.svg";